/* Activities gallery (sections/activities-gallery.liquid): topic + grade filters, search, counts, load more on scroll. */
(function () {
  var root = document.querySelector('[data-axg]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var cards = Array.prototype.slice.call(root.querySelectorAll('.cxg__card'));
  var pills = Array.prototype.slice.call(root.querySelectorAll('.cxg__pill'));
  var levels = Array.prototype.slice.call(root.querySelectorAll('.cxg__level'));
  var toggle = root.querySelector('.cxg__toggle');
  var panel = root.querySelector('.cxg__packs');
  var summary = root.querySelector('[data-cxg-summary]');
  var clearBtn = root.querySelector('[data-cxg-clear]');
  var sentinel = root.querySelector('[data-cxg-sentinel]');
  var empty = root.querySelector('[data-cxg-empty]');
  var emptyText = root.querySelector('[data-cxg-empty-text]');
  var searchAll = root.querySelector('[data-cxg-search-all]');
  var search = root.querySelector('[data-cxg-search]');
  var mq = window.matchMedia('(max-width: 699px)');
  var deskBatch = parseInt(root.dataset.desktopBatch, 10) || 12;
  var mobBatch = parseInt(root.dataset.mobileBatch, 10) || 10;

  var params = new URLSearchParams(location.search);
  var state = { topic: params.get('topic') || '', grade: params.get('grade') || '', q: params.get('q') || '', limit: 0 };

  function norm(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  cards.forEach(function (c) { var n = c.querySelector('.cxg__name'); c.dataset.q = ' ' + norm(n ? n.textContent : '') + ' '; });
  function searching() { return !!norm(state.q); }
  /* every word typed must appear somewhere in the name */
  function hasQ(c) { var w = norm(state.q); return !w || w.split(' ').every(function (x) { return c.dataset.q.indexOf(x) !== -1; }); }
  function hasTopic(c, k) { return !k || (c.dataset.packs || '').indexOf('|' + k + '|') !== -1; }
  function hasGrade(c, g) { return !g || (c.dataset.grades || '').indexOf('|' + g + '|') !== -1; }
  /* series: one card for the whole series, unless a grade is picked and only some of its activities fit that grade */
  var members = {};
  cards.forEach(function (c) { if (c.dataset.role === 'member') (members[c.dataset.parent] = members[c.dataset.parent] || []).push(c); });
  var byId = {};
  cards.forEach(function (c) { byId[c.dataset.id] = c; });
  function wholeSeries(id, g) { var m = members[id] || []; return !g || !m.length || m.every(function (x) { return hasGrade(x, g); }); }
  function shows(c, k, g) {
    var role = c.dataset.role;
    if (role === 'series') return hasTopic(c, k) && (!g || ((members[c.dataset.id] || []).length ? wholeSeries(c.dataset.id, g) : hasGrade(c, g)));
    if (role === 'member' && byId[c.dataset.parent]) return !!g && hasTopic(c, k) && hasGrade(c, g) && !wholeSeries(c.dataset.parent, g);
    return hasTopic(c, k) && hasGrade(c, g);
  }
  function passes(c) { return searching() ? hasQ(c) : shows(c, state.topic, state.grade); }
  function count(fn) { var n = 0; for (var i = 0; i < cards.length; i++) if (fn(cards[i])) n++; return n; }
  function batch() { return mq.matches ? mobBatch : deskBatch; }

  /* topics with no activities are hidden; unknown values in the address are ignored */
  pills.forEach(function (p) { var k = p.dataset.pack; if (k && count(function (c) { return shows(c, k, '') || shows(c, k, 'prek-k') || shows(c, k, '1-2') || shows(c, k, '3-5'); }) === 0) p.remove(); });
  pills = Array.prototype.slice.call(root.querySelectorAll('.cxg__pill'));
  if (state.topic && !root.querySelector('.cxg__pill[data-pack="' + state.topic + '"]')) state.topic = '';
  if (['', 'prek-k', '1-2', '3-5'].indexOf(state.grade) === -1) state.grade = '';

  function render() {
    var matches = cards.filter(passes);
    var limit = state.limit || batch();
    cards.forEach(function (c) { c.hidden = true; });
    matches.forEach(function (c, i) { c.hidden = i >= limit; });

    pills.forEach(function (p) {
      var on = !searching() && p.dataset.pack === state.topic;
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
      var n = count(function (c) { return shows(c, p.dataset.pack, state.grade); });
      p.querySelector('[data-cxg-count]').textContent = n;
      p.classList.toggle('is-empty', n === 0 && !on);
    });
    levels.forEach(function (b) {
      var on = searching() ? !b.dataset.level : b.dataset.level === state.grade;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.querySelector('[data-cxg-count]').textContent = count(function (c) { return shows(c, state.topic, b.dataset.level); });
    });

    var active = root.querySelector('.cxg__pill[data-pack="' + state.topic + '"]');
    var topicName = state.topic && active && !searching() ? active.dataset.name : '';
    root.querySelector('[data-cxg-current]').textContent = topicName || 'All topics';
    var curDot = root.querySelector('[data-cxg-current-dot]');
    var activeDot = topicName ? active.querySelector('.cxg__dot') : null;
    curDot.hidden = !activeDot;
    if (activeDot) curDot.style.background = activeDot.style.background;
    root.querySelector('[data-cxg-current-count]').textContent = count(function (c) { return shows(c, state.topic, state.grade); });

    var n = matches.length;
    var gradeBtn = root.querySelector('.cxg__level[data-level="' + state.grade + '"]');
    var gradeName = state.grade && !searching() && gradeBtn ? gradeBtn.dataset.name : '';
    var words = n + ' ' + (topicName ? topicName + ' ' : '') + (n === 1 ? 'activity' : 'activities') +
      (gradeName ? ' for ' + gradeName : '') + (searching() ? ' matching “' + state.q.trim() + '”' : '');
    summary.textContent = words;
    clearBtn.hidden = !state.topic && !state.grade && !state.q;
    empty.hidden = n !== 0;
    if (n === 0) {
      emptyText.textContent = searching() ? 'No activities called “' + state.q.trim() + '”. Try another name.' : 'No activities match these filters yet. Try another topic or grade.';
      searchAll.hidden = searching();
    }
    state.more = n > limit;
  }

  function setUrl() {
    var q = new URLSearchParams(location.search);
    state.topic ? q.set('topic', state.topic) : q.delete('topic');
    state.grade ? q.set('grade', state.grade) : q.delete('grade');
    state.q.trim() ? q.set('q', state.q.trim()) : q.delete('q');
    var s = q.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
  }

  pills.forEach(function (p) {
    p.addEventListener('click', function () {
      var k = p.dataset.pack;
      if (searching()) { state.q = ''; search.value = ''; state.topic = k; } else state.topic = state.topic === k ? '' : k;
      state.limit = 0;
      if (mq.matches) { panel.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
      setUrl(); render();
    });
  });
  levels.forEach(function (b) {
    b.addEventListener('click', function () { state.q = ''; search.value = ''; state.grade = b.dataset.level; state.limit = 0; setUrl(); render(); });
  });
  toggle.addEventListener('click', function () {
    var open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  function clearAll() { state.topic = ''; state.grade = ''; state.q = ''; search.value = ''; state.limit = 0; setUrl(); render(); }
  clearBtn.addEventListener('click', clearAll);
  searchAll.addEventListener('click', clearAll);
  search.value = state.q;
  search.addEventListener('input', function () { state.q = search.value; state.limit = 0; setUrl(); render(); });
  search.addEventListener('keydown', function (e) { if (e.key === 'Escape') { search.value = ''; state.q = ''; setUrl(); render(); } });

  /* load the next batch when the end of the list comes into view */
  var ticking = false;
  function maybeLoad() {
    ticking = false;
    if (!state.more) return;
    if (sentinel.getBoundingClientRect().top < window.innerHeight + 600) {
      state.limit = (state.limit || batch()) + batch();
      render();
      setTimeout(maybeLoad, 50);
    }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; setTimeout(maybeLoad, 100); } }, { passive: true });
  (mq.addEventListener ? mq.addEventListener('change', function () { state.limit = 0; render(); }) : mq.addListener(function () { state.limit = 0; render(); }));

  render();
})();
